<template>
  <div>
    <div
      style="padding-bottom:10vh;"
      class="overflow-auto"
      v-if="isMobileOrTablet"
    >
      <appHeader></appHeader>
      <div class="container-fluid account overflow-auto">
        <div class="row overflow-hidden">
          <div class="pr-0 col-sm-12">
            <appAccountSidebar></appAccountSidebar>
          </div>
          <transition appear name="fade">
            <div v-if="!itemsInitialized">
              <!--Loading...-->
            </div>
            <div v-else-if="items.length === 0" class="col-md-9 text-center">
              <h6 class="mt-4">No history to show yet</h6>
              <img
                alt="empty history"
                class="m-4 b-4"
                src="../../assets/images/list.png"
                style="max-width:400px"
              />
            </div>
            <div v-else class="px-3" style="overflow-x:hidden;">
              <h6>Account History</h6>
              <div class="row col-md-12" style="padding:0;margin:0;">
                <b-table
                  :fields="fields"
                  :items="items"
                  :sort-by.sync="sortBy"
                  :sort-desc.sync="sortDesc"
                  class="table table-hover table-responsive table-striped my-3"
                  responsive="sm"
                  sort-icon-left
                  style="overflow-x:scroll;"
                >
                  <template v-slot:cell(points)="data">
                    <span
                      v-if="data.item.isNegative"
                      class="badge badge-danger"
                      >{{ data.item.points | numToLocale }}</span
                    >
                    <span
                      v-else-if="data.item.isPositive"
                      class="badge badge-success"
                      >{{ data.item.points | numToLocale }}</span
                    >
                  </template>
                  <template v-slot:cell(product)="data">
                    {{ data.item.productName }}
                    <div
                      v-if="
                        data.item.productSpecName && data.item.productSpecValue
                      "
                      style="width:200px"
                    >
                      <strong>{{ data.item.productSpecName }}: </strong>
                      {{ data.item.productSpecValue }}
                    </div>
                    <router-link
                      v-if="data.item.productId"
                      :to="{
                        name: 'Product',
                        params: { productId: data.item.productId },
                      }"
                      class="d-block mt-1"
                    >
                      <font-awesome-icon
                        icon="cart-plus"
                        transform="shrink-3"
                      />
                      Buy Again
                    </router-link>
                  </template>
                  <template v-slot:cell(date)="data">{{
                    data.item.date | formatDate
                  }}</template>
                  <template v-slot:cell(type)="data">{{
                    data.item.type | titleCase
                  }}</template>
                </b-table>
              </div>
            </div>
          </transition>
        </div>
      </div>
      <appFooter></appFooter>
      <navigationFooter></navigationFooter>
    </div>
    <div v-else class="mt-5">
      <appHeader></appHeader>
      <div class="container-fluid account">
        <div class="row">
          <div class="col-md-3 col-sm-12 pr-0 dark-bg">
            <appAccountSidebar></appAccountSidebar>
          </div>
          <transition appear name="fade">
            <div v-if="!itemsInitialized">
              <!--Loading...-->
            </div>
            <div v-else-if="items.length === 0" class="col-md-9 text-center">
              <h6 class="mt-4">No history to show yet</h6>
              <img
                alt="empty history"
                class="m-4 b-4"
                src="../../assets/images/list.png"
                style="max-width:400px"
              />
            </div>
            <div v-else class="col-md-9 p-4">
              <h6>Account history</h6>
              <div class="row col-md-12">
                <b-table
                  :fields="fields"
                  :items="items"
                  :sort-by.sync="sortBy"
                  :sort-desc.sync="sortDesc"
                  class="table table-hover table-responsive table-striped my-3"
                  responsive="sm"
                  sort-icon-left
                >
                  <template v-slot:cell(points)="data">
                    <span
                      v-if="data.item.isNegative"
                      class="badge badge-danger"
                      >{{ data.item.points | numToLocale }}</span
                    >
                    <span
                      v-else-if="data.item.isPositive"
                      class="badge badge-success"
                      >{{ data.item.points | numToLocale }}</span
                    >
                    <span
                      v-else-if="data.item.isBonusPointsNegative"
                      class="badge badge-danger"
                      >{{ data.item.points | numToLocale }} Swag Points</span
                    >
                    <span
                      v-else-if="data.item.isBonusPointsPositive"
                      class="badge badge-success"
                      >{{ data.item.points | numToLocale }} Swag Points</span
                    >
                  </template>
                  <template v-slot:cell(product)="data">
                    {{ data.item.productName }}
                    <div
                      v-if="
                        data.item.productSpecName && data.item.productSpecValue
                      "
                    >
                      <strong>{{ data.item.productSpecName }}: </strong>
                      {{ data.item.productSpecValue }}
                    </div>
                    <router-link
                      v-if="data.item.productId"
                      :to="{
                        name: 'Product',
                        params: { productId: data.item.productId },
                      }"
                      class="d-block mt-1"
                    >
                      <font-awesome-icon
                        icon="cart-plus"
                        transform="shrink-3"
                      />
                      Buy Again
                    </router-link>
                  </template>
                  <template v-slot:cell(date)="data">{{
                    data.item.date | formatDate
                  }}</template>
                  <template v-slot:cell(type)="data">{{
                    data.item.type | titleCase
                  }}</template>
                </b-table>
              </div>
            </div>
          </transition>
        </div>
      </div>
      <appFooter></appFooter>
    </div>
  </div>
</template>

<script>
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import AccountSidebar from "./AccountSidebar.vue";
import navigationFooter from "../../components/navigationFooter.vue";
import moment from "moment";
import { isMobile, isTablet } from "mobile-device-detect";
import { mapState } from "vuex";

export default {
  data() {
    return {
      sortBy: "date",
      sortDesc: true,
      fields: [
        {
          key: "date",
          sortable: true,
        },
        {
          key: "type",
          sortable: true,
        },
        {
          key: "points",
          sortable: true,
        },
        {
          key: "order_number",
          label: "Order number",
          sortable: true,
        },
        {
          key: "product",
          label: "Product",
          sortable: true,
        },
        {
          key: "comments",
          sortable: false,
        },
        {
          key: "program",
          sortable: false,
        },
      ],
    };
  },
  computed: {
    ...mapState({
      items: function(state) {
        const positiveTransactions = [
          "points added",
          "api points added",
          "rebate",
          "credit",
          "api points increase",
          "credit tax",
          "credit sales tax",
        ];
        const negativeTransactions = [
          "order",
          "order tax",
          "sales tax",
          "points subtracted",
          "api points removed",
        ];
        const otherSupportedTransactions = [
          "user added",
          "user locked",
          "user updated",
          "password changed",
          "user unlocked",
          "api user updated",
          "pending order",
        ];
        const bonusPointsPositiveTransactions = [
          "bonuspoints added",
        ];
        const bonusPointsNegativeTransactions = [
          "bonuspoints removed",
          "bonuspoints order",
        ];
        return state.user.transactions
          .filter(
            (transaction) =>
              positiveTransactions.includes(transaction.type.toLowerCase()) ||
              negativeTransactions.includes(transaction.type.toLowerCase()) ||
              bonusPointsPositiveTransactions.includes(transaction.type.toLowerCase()) ||
              bonusPointsNegativeTransactions.includes(transaction.type.toLowerCase()) ||
              otherSupportedTransactions.includes(
                transaction.type.toLowerCase()
              )
          )
          .map((transaction) => ({
            date: transaction.date,
            type: transaction.type,
            points: transaction.points,
            order_number: transaction.orderNumber,
            productId: transaction.productId,
            productName: transaction.productName,
            productSpecName: transaction.productSpecName,
            productSpecValue: transaction.productSpecValue,
            comments: transaction.comments,
            program: transaction.program,
            isPositive: positiveTransactions.includes(
              transaction.type.toLowerCase()
            ),
            isBonusPointsPositive: bonusPointsPositiveTransactions.includes(
              transaction.type.toLowerCase()
            ),
            isNegative: negativeTransactions.includes(
              transaction.type.toLowerCase()
            ),
            isBonusPointsNegative: bonusPointsNegativeTransactions.includes(
              transaction.type.toLowerCase()
            ),
          }));
      },
      itemsInitialized: (state) => state.user.status.transactions.initialized,
    }),
    isMobileOrTablet: function() {
      return isMobile || isTablet;
    },
  },
  components: {
    appHeader: Header,
    appFooter: Footer,
    appAccountSidebar: AccountSidebar,
    navigationFooter: navigationFooter,
  },
  methods: {},
  created() {
    this.$store.dispatch("user/fetchTransactions");
  },
};
</script>

<style lang="scss" scoped>
.account {
  margin: -14px 0 0 0;
  .badge {
    font-size: 0.8rem;
    padding: 6px 8px;
    border-radius: $border-radius-sm;
  }
}
</style>
